import '@/styles/global.css'
import { bootstrap } from '@/app/bootstrap'

window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

bootstrap()
